import React from 'react';

export const VERSION_DESCRIPTIONS = [
  // {
  //   title: '',
  //   description: {
  //     de: '',
  //     en: '',
  //   },
  // },
  {
    title: 'v1.0.0',
    description: {
      de: (
        <span>
        Das ist das erste offizielle
          <span style={{ fontWeight: 'bold' }}> Release</span>
        </span>
      ),
      en: 'That is the first official release',
    },
  },
];
